import { render } from "./TalentListCard.vue?vue&type=template&id=0534b608&scoped=true&ts=true&lang=pug"
import script from "./TalentListCard.vue?vue&type=script&lang=ts"
export * from "./TalentListCard.vue?vue&type=script&lang=ts"

import "./TalentListCard.vue?vue&type=style&index=0&id=0534b608&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0534b608"]])

export default __exports__